<template>
<div class="all-wrapper">

  <form @submit.prevent="login">
  <div class="login-bloc"> 
  <div class="login-wrapper">
     <div align="center" width="100%">
        <p v-if="error" class="error-co">Adresse email ou mot de passe invalide</p>
    </div>
    <div class="login-element">
          <img class="logologin" src="/logo.png">
    </div>     
    <div class="login-element">
        <input class="new-input" type="email" required 
                v-model="username" 
                id="email"
                name="email"
              
                >
        <label class="label" for="email"><i class="fa fa-envelope-o" aria-hidden="true"></i> ADRESSE EMAIL</label>  
        <span class="error-new">{{ errors.first('email') }}</span> 
    </div>
     <div class="login-element">
        <input class="new-input" type="password"  required 
               id="password" 
               name="password"
               v-model="password" 
               v-validate="'required'" 
               >
       <label class="label" for="password"><i class="fa fa-lock" aria-hidden="true"></i> MOT DE PASSE</label> 
      <span class="error-new">{{ errors.first('password') }}</span>    
      </div>   
      <div class="login-element form-group">
      <br />
      <input type="checkbox" 
                v-model="remember" 
                id="remember">
         <label for="remember" class="labelsmall">Se souvenir de moi</label>     
      </div> 
      <div class="login-element">
          <div align="center" width="100%"><button class="btn-blue button_slide  slide_right" type="submit"><i class="fa fa-sign-in" aria-hidden="true"></i> Login</button></div>
          <br />
      </div>
  </div>
</div>

  </form> 
</div>
</template>

<script>
import auth from '../auth'

  export default {
    data () {
      return {
        username: '',
        password: '',
        remember :false,
        error: false
      }
    },
    methods: {
      async login () {
        auth.login(this.username, this.password, loggedIn => {
          if (!loggedIn) {
            this.error = true
          } else {

            if(this.remember) {  
              localStorage.username = this.username
              localStorage.password = this.password
              this.remember = true
            } else {
              localStorage.username = ''
              localStorage.password = ''
            }
            window.location = '/';
            // this.$router.replace(this.$route.query.redirect || '/')
          }
        })
      }
    },
  async mounted() {
    if (this.$route.query.expired !== undefined) {
      this.$router.replace({query: {}})
      alert('Session expirée. Veuillez vous reconnecter')
    }
    if (localStorage.username) {
      this.username = localStorage.username;
      this.password = localStorage.password;
      this.remember = true;
    }
  }
  }
</script>

<style>
.login-bloc {
  width: 650px;
  background-color: white;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.15);
  margin-top:50px;
}

@media (max-width: 768px) {
  .login-bloc {
    width: 95%;
  }
}


.login-wrapper {
  width: 90%;

}

.login-element {
   position: relative;
   margin-top:25px;
}



.slide_right:hover {
  background-position: right center; /* change the direction of the change here */
  color: #fff;
  }
 

.button_slide {
  background-image: linear-gradient(to right, #77A1D3 0%, #79CBCA  51%, #77A1D3  100%) ;   
  margin: 10px;
  padding: 12px 40px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;            
  box-shadow: 0 0 20px #eee;
  border-radius: 0px;
  display: block;  
  font-size: 18px; 
  text-transform: none;  
}

.new-input {
  position: relative !important;
  display: block !important;
  width: 100% !important;
  border: none !important;
  border-radius: unset !important;
  border-bottom: 1px solid #DDD !important;
  background-color: transparent !important;
  box-shadow:unset !important;
  background:unset !important;
  margin: 0px auto!important;
  padding: 20px 0px 0px 0px !important;
  height: 32px !important;
  outline: none !important;
  font-size: 15px !important;
  color: rgba(0,0,0,0.8) !important;
  background: -webkit-linear-gradient(bottom, #6b88a4 50%, #6b88a4  50%) !important;
  background: linear-gradient(to top, #6b88a4  50%, #6b88a4  50%) !important;
  background-position: left bottom !important;
  background-size: 0 1px !important;
  background-repeat: no-repeat !important;
  transition: all .2s ease-in-out !important;
  font-weight: bold;
}


.label {
  position: absolute !important;
  bottom: -20px !important; 
  left: 0 !important;
  text-align: left !important;
  display: block !important;
  width: 100% !important;
  height: 52px !important;
  line-height: 72px !important;
  text-transform: uppercase !important;
  line-height: 20px !important; 
  font-size: 15px !important;
  background: transparent !important;
  color: rgba(0,0,0,0.4) !important;
  margin: 0px auto !important;
  cursor: text !important;
  transition: all .15s ease-in-out !important;
}

.new-input:hover, .new-input:focus { border-color: #1e334f !important; }
.new-input:focus { 
  background-position: left bottom !important;
  background-size: 100% 1px !important;
}

.new-input:focus + label, .new-input:valid + label { 
  height: 20px !important; 
  line-height: 20px !important; 
  font-size: 14px !important;
  color: #6b88a4 !important;
  bottom:35px !important;
}



.step-contenair {
  width: 100%;
  padding : 50px;
}

.elem {
  width: 40% !important;
}

.error-new {
  position: absolute;
  bottom:-18px !important;
  width: 100%;
  text-align: right;
  color:#df233c;
  font-size: 12px;
  font-weight: bold;
}

.error-co {
  color:#df233c;
  font-weight: bold;
}


.form-group {
  display: block;
  margin-bottom: 15px;
}

.form-group input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.form-group label {
  position: relative;
  cursor: pointer;
  font-size:12.5px;
  color: #6b88a4;
  font-weight: bold;
}

.form-group label:before {
  content:'';
  -webkit-appearance: none;
  background-color: transparent;
  border: 2px solid #6b88a4;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 6px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
}

.form-group input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 2.5px;
  left: 11.5px;
  width: 2px;
  height: 7px;
  border: solid #229022;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

@media (min-width: 768px) {
.all-wrapper {
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
}
 
</style>